import { render, staticRenderFns } from "./WaterEquipmentInfo.vue?vue&type=template&id=070bb4f9&scoped=true&"
import script from "./WaterEquipmentInfo.vue?vue&type=script&lang=js&"
export * from "./WaterEquipmentInfo.vue?vue&type=script&lang=js&"
import style0 from "./WaterEquipmentInfo.vue?vue&type=style&index=0&id=070bb4f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070bb4f9",
  null
  
)

export default component.exports